module.exports = __webpack_public_path__ + "static/koenigsberg-graph-6b80ddffa04e28bb3fcac3701a03e985.png";